module.exports = __webpack_public_path__ + "img/icono-centralpos.cb4df64f.svg";